import { render, staticRenderFns } from "./OrderStatusKey.vue?vue&type=template&id=39954693&"
import script from "./OrderStatusKey.vue?vue&type=script&lang=js&"
export * from "./OrderStatusKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports